import React, { useEffect, useState } from 'react'
import { CloseBtn } from '../../../components/CloseBtn'
import { Button } from '../../../components/Button'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { FormInput } from '../../../components/FormInput'
import styles from './FormPage.module.scss'
import schools from '../../../assets/schools.json'
import { Card } from 'src/components/Card'
import editIcon from '../../../assets/icons/icn_edit-b.svg'
import { sendForm, formatUnionItems } from '../../../helpers/sendForm'

interface IProps {
  setPage: (number: number) => void
  nextStep: () => void
}

export const FormPage = ({ setPage, nextStep }: IProps) => {
  const items = window.localStorage.getItem('Union-savedUnionItems') || '[]'

  const [step, setStep] = useState(0)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [school, setSchool] = useState('')
  const [role, setRole] = useState('')
  const [schoolAddress, setSchoolAddress] = useState('')
  const [schoolPost, setSchoolPost] = useState('')
  const [schoolCity, setSchoolCity] = useState('')
  const [studentUnion, setStudentUnion] = useState('')
  const [payment, setPayment] = useState('marketingBudget')

  const [accountName, setAccountName] = useState('')
  const [organisationNumber, setOrganisationNumber] = useState('')
  const [invoiceAddress, setInvoiceAddress] = useState('')
  const [invoicePostNumber, setInvoicePostNumber] = useState('')
  const [invoiceCity, setInvoiceCity] = useState('')
  const [invoiceEmail, setInvoiceEmail] = useState('')

  const [validationError, setValidationError] = useState(false)

  const validation = {
    name: /^\s*(?:(?:\b[a-zA-Z]+\b)\s*){1,4}$/,
    email: /\S+@\S+\.\S+/,
    mobile: /^\+?\d{5,}$/,
    school: /^.+$/,
    role: /^.{1,}$/,
    schoolAddress: /^.{4,}$/,
    schoolPost: /^\d{4,7}$/,
    schoolCity: /^.{4,}$/,
    studentUnion: /^.{4,}$/,
    accountName: /^.{5,}$/,
    accountNumber: /^\d{5,}$/,
    organisationNumber: /^\d{3,}$/,
  }

  useEffect(() => {
    window.localStorage.setItem('Union-step', '7')
    window.localStorage.removeItem('Union-clothType')
    window.localStorage.removeItem('Union-color')
  }, [])

  const getBack = () => {
    setPage(5)
  }

  const validationCheckPersonalData = () => {
    if (!validation.name.test(name)) {
      setValidationError(true)
      return false
    }
    if (!validation.email.test(email)) {
      setValidationError(true)
      return false
    }
    if (!validation.mobile.test(mobile)) {
      setValidationError(true)
      return false
    }
    if (!validation.school.test(school)) {
      setValidationError(true)
      return false
    }
    if (!validation.role.test(role)) {
      setValidationError(true)
      return false
    }
    if (!validation.schoolAddress.test(schoolAddress)) {
      setValidationError(true)
      return false
    }
    if (!validation.schoolPost.test(schoolPost)) {
      setValidationError(true)
      return false
    }
    if (!validation.schoolCity.test(schoolCity)) {
      setValidationError(true)
      return false
    }
    // if (!validation.studentUnion.test(studentUnion)) {
    //   setValidationError(true)
    //   return false
    // }
    setValidationError(false)
    return true
  }

  const validationCheckSecondForm = () => {
    if (payment === 'invoice') {
      if (!validation.accountName.test(accountName)) {
        setValidationError(true)
        return false
      }

      // if (!validation.accountName.test(accountName)) {
      //   setValidationError(true)
      //   return false
      // }

      if (!validation.organisationNumber.test(organisationNumber)) {
        setValidationError(true)
        return false
      }

      if (!validation.schoolAddress.test(invoiceAddress)) {
        setValidationError(true)
        return false
      }

      if (!validation.organisationNumber.test(invoicePostNumber)) {
        setValidationError(true)
        return false
      }

      if (!validation.name.test(invoiceCity)) {
        setValidationError(true)
        return false
      }

      if (!validation.email.test(invoiceEmail)) {
        setValidationError(true)
        return false
      }

    }
    setValidationError(false)
    return true
  }

  const next = () => {
    if (step === 0 && validationCheckPersonalData()) {
      setStep(1)
    }
  }

  const sendData = () => {
    if (step === 1 && validationCheckSecondForm()) {
      const formData = {
        name,
        email,
        mobile,
        school,
        role,
        schoolAddress,
        schoolPost,
        schoolCity: schoolCity,
        // studentUnion,
        payment,
        accountName,
        organisationNumber,
        invoiceAddress,
        invoicePostNumber,
        invoiceCity,
        invoiceEmail,
        items: formatUnionItems(JSON.parse(items)),
      }
      // return;
      sendForm( 'union', formData, nextStep)
    }
  }

  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.Title}>
          <CloseBtn cancel={getBack}/>
          <div className={styles.MainTitile}>
            <FormattedMessage id="CompleteOrder.title"/>
          </div>
          <div className={styles.CompleteOrderDescription}>
            <FormattedMessage id="CompleteOrder.description"/>
          </div>
          <div className={styles.CompleteOrderTitle}>
            <FormattedMessage id="CompleteOrder.tableTitle"/>
          </div>
          {step === 0 &&
          <>
              <div className={styles.Form}>
              <div className={styles.FormItemLeft}>
                      <FormInput
                          value={name}
                          onChange={setName}
                          validation={validation.name}
                          title={'Form.title.name'}
                          placeholder="Kristina Svensson"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={email}
                          onChange={setEmail}
                          validation={validation.email}
                          title={'Form.title.email'}
                          placeholder="kristina.svensson@email.com"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={mobile}
                          onChange={setMobile}
                          type="number"
                          validation={validation.mobile}
                          title={'Form.title.mobile'}
                          placeholder="07001442125"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={role}
                          onChange={setRole}
                          title={'Form.title.role'}
                          validation={validation.role}
                          placeholder="Ordförande"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={school}
                          onChange={setSchool}
                          title={'Form.title.school'}
                          validation={validation.school}
                          placeholder="Välj din skola"
                          select={schools}
                          selectDefault={'Form.misc.noSchool'}
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={schoolAddress}
                          onChange={setSchoolAddress}
                          title={'Form.title.schoolAdress'}
                          validation={validation.schoolAddress}
                          placeholder="Gatunamn 1"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={schoolPost}
                          onChange={setSchoolPost}
                          title={'Form.title.schoolPost'}
                          validation={validation.schoolPost}
                          placeholder={'45322'}
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={schoolCity}
                          onChange={setSchoolCity}
                          title={'Form.title.schoolCity'}
                          validation={validation.schoolCity}
                          placeholder={'Stockholm'}
                          validationCheck={validationError}
                      />
                  </div>
                  {/* <FormInput
                      value={studentUnion}
                      onChange={setStudentUnion}
                      title={'AT(Student union)'}
                      validation={validation.studentUnion}
                      placeholder={'Free Union'}
                      validationCheck={validationError}
                  /> */}

              </div>
              <div className={styles.Terms}>
                <a href="https://www.abcgruppen.se/kopvillkor/" target="_blank" rel="noreferrer">
                  <FormattedMessage id="CompleteOrder.terms"/>
                </a>
              </div>
          </>
          }
        </div>
        {step === 0 &&
        <Button
            center
            onClick={next}
            buttonColor
            buttonDescription="SchoolShop.stage2.button"
        />
        }
        {step === 1 &&
        <>
            <Card>
                <div className={styles.Info}>
                    <div className={styles.YourInformationTextBlock}>
                        <h4>{name}</h4>
                        <p><span>{email}</span>, <span>{mobile}</span></p>
                        <h4 className={styles.MarginBlock}>{schools.filter((item) => item.id === school)[0]?.name}</h4>
                      <p><span>{schoolAddress}</span>, <span>{schoolPost}</span> <span>{schoolCity}</span>
                            <span>{studentUnion}</span>
                        </p>
                    </div>
                    <button onClick={() => setStep(0)}
                            className={styles.CardButton}>
                        <img src={editIcon} alt='edit'/>
                    </button>
                </div>

            </Card>
            <div className={styles.DoneWrapper}>
                <div className={styles.Terms}>
                  <a href="https://www.abcgruppen.se/kopvillkor/" target="_blank" rel="noreferrer">
                    <FormattedMessage id="CompleteOrder.terms"/>
                  </a>
                </div>
                <h3 className={styles.FormTitle}><FormattedMessage id="UnionCloth.formPage.formTitle"/></h3>
                <div className={styles.PaymentOptions}>
                    <div onClick={() => {
                      setPayment('marketingBudget')
                    }}>

                  <div className={styles.RadioContainer}>
                  <div className={styles.Radio}>
                    <input id="radio-1" name="radio" type="radio" checked={payment === 'marketingBudget'}/>
                    <label htmlFor="radio-1" className={styles.RadioLabel}>

                    </label>
                    <div className={styles.RadioText}>
                      <h3 className={styles.PaymentTitle}><FormattedMessage id="UnionCloth.formPage.budget"/></h3>
                      <p className={styles.PaymentDescription}><FormattedMessage id="UnionCloth.formPage.budgetDescription"/></p>
                    </div>
                  </div>
                  </div>


                    </div>
                    <span className={styles.Line}></span>
                    <div onClick={() => {
                      setPayment('invoice')
                    }}>

                      <div>
                  <div className={styles.Radio}>
                    <input id="radio-2" name="radio" type="radio" checked={payment === 'invoice'}/>
                    <label htmlFor="radio-2" className={styles.RadioLabel}>

                    </label>
                    <div  className={styles.RadioText}>
                    <h3 className={styles.PaymentTitle}><FormattedMessage id="UnionCloth.formPage.invoice"/></h3>
                      <p className={styles.PaymentDescription}><FormattedMessage id="UnionCloth.formPage.invoiceDescription"/></p>
                    </div>
                  </div>
                  </div>



                    </div>
                </div>
              {payment === 'invoice' &&
              <>
                  <h3 className={styles.FormTitle}><FormattedMessage id="UnionCloth.formPage.formTitle2"/></h3>
                  <div className={styles.Form}>
                  <div className={styles.FormItemLeft}>
                          <FormInput
                              value={accountName}
                              onChange={setAccountName}
                              validation={validation.name}
                              title={'Namn'}
                              placeholder="Söderbergs elevkår "
                              validationCheck={validationError}
                          />
                      </div>
                      <div className={`${styles.FormItemRight}`}>
                          <FormInput
                              value={organisationNumber}
                              onChange={setOrganisationNumber}
                              title={'Organisationsnummer/Personnummer'}
                              validation={validation.organisationNumber}
                              placeholder={'123456-1234'}
                              validationCheck={validationError}
                          />
                      </div>
                      <div className={styles.FormItemLeft}>
                          <FormInput
                              value={invoiceAddress}
                              onChange={setInvoiceAddress}
                              title={'Gatuadress'}
                              validation={validation.schoolAddress}
                              placeholder={'Fakturavägen 1'}
                              validationCheck={validationError}
                          />
                      </div>

                      <div className={`${styles.FormItemRight}`}>
                          <FormInput
                              value={invoicePostNumber}
                              onChange={setInvoicePostNumber}
                              title={'Postnummer'}
                              validation={validation.organisationNumber}
                              placeholder={'1234-56'}
                              validationCheck={validationError}
                          />
                      </div>

                      <div className={`${styles.FormItemLeft}`}>
                          <FormInput
                              value={invoiceCity}
                              onChange={setInvoiceCity}
                              title={'Stad'}
                              validation={validation.name}
                              placeholder={'Stockholm'}
                              validationCheck={validationError}
                          />
                      </div>

                      <div className={`${styles.FormItemRight}`}>
                          <FormInput
                              value={invoiceEmail}
                              onChange={setInvoiceEmail}
                              title={'Fakturamail'}
                              validation={validation.email}
                              placeholder={'Faktura@elevkaren.se'}
                              validationCheck={validationError}
                          />
                      </div>
                  </div>
              </>
              }


                <div className={styles.ButtonCenter}>
                    <Button
                        center
                        onClick={sendData}
                        buttonDescription={"UnionCloth.titleSection.button"}
                        classWidth
                    />
                </div>
            </div>
        </>
        }
      </div>

    </>
  )
}
